// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BREAKPOINTS */
.Submenu_submenu__oXoEy {
  z-index: 10;
  background: var(--background-color-1);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.25);
  color: var(--foreground-color-1);
  animation-duration: 0.3s;
}
@media (min-width: 768px) {
  .Submenu_submenu__oXoEy {
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
  }
}
@media (min-width: 768px) {
  .Submenu_submenu__oXoEy .Submenu_submenu__oXoEy {
    border-bottom-left-radius: 0;
    border-top-right-radius: 1em;
  }
  .Submenu_submenu__oXoEy .Submenu_submenu__oXoEy > ul {
    border-bottom-left-radius: 0;
    border-top-right-radius: 1em;
  }
}
@media (max-width: 767.98px) {
  .Submenu_submenu__oXoEy {
    width: 100%;
  }
}
.Submenu_submenu__oXoEy.Submenu_hidden__rA06C {
  display: none;
}
.Submenu_submenu__oXoEy .Submenu_submenuArrow__Z84U8 {
  width: 0;
  height: 0;
  border: 7px solid transparent;
  border-bottom-color: var(--background-color-1);
  top: -13px;
}
.Submenu_submenu__oXoEy > ul {
  overflow: hidden;
}
@media (min-width: 768px) {
  .Submenu_submenu__oXoEy > ul {
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
  }
}
.Submenu_submenu__oXoEy > ul > li {
  position: relative;
}
.Submenu_submenu__oXoEy > ul > li a,
.Submenu_submenu__oXoEy > ul > li button {
  display: flex;
  align-items: center;
  height: 3em;
  width: 100%;
  background: none;
  border: none;
  color: var(--foreground-color-2);
  font-weight: var(--bold);
  cursor: pointer;
  padding: 0 2em 0 1em;
}
.Submenu_submenu__oXoEy > ul > li a[aria-haspopup=true],
.Submenu_submenu__oXoEy > ul > li button[aria-haspopup=true] {
  padding: 0 1em;
}
.Submenu_submenu__oXoEy > ul > li a:hover, .Submenu_submenu__oXoEy > ul > li a.focus-visible, .Submenu_submenu__oXoEy > ul > li a[aria-expanded=true],
.Submenu_submenu__oXoEy > ul > li button:hover,
.Submenu_submenu__oXoEy > ul > li button.focus-visible,
.Submenu_submenu__oXoEy > ul > li button[aria-expanded=true] {
  transition: all 0.3s ease;
  outline: none;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
  padding: 1.5em;
  background: var(--foreground-color-1);
  color: var(--background-color-1);
}
.Submenu_submenu__oXoEy > ul > li a:hover[aria-haspopup=true], .Submenu_submenu__oXoEy > ul > li a.focus-visible[aria-haspopup=true], .Submenu_submenu__oXoEy > ul > li a[aria-expanded=true][aria-haspopup=true],
.Submenu_submenu__oXoEy > ul > li button:hover[aria-haspopup=true],
.Submenu_submenu__oXoEy > ul > li button.focus-visible[aria-haspopup=true],
.Submenu_submenu__oXoEy > ul > li button[aria-expanded=true][aria-haspopup=true] {
  padding: 0 0.5em 0 1.5em;
}
.Submenu_submenu__oXoEy > ul > li a > * + *,
.Submenu_submenu__oXoEy > ul > li button > * + * {
  margin-left: 1em;
}
.Submenu_submenu__oXoEy > ul > li a .Submenu_icon__QL2aK,
.Submenu_submenu__oXoEy > ul > li button .Submenu_icon__QL2aK {
  padding-left: 0.5em;
  margin-left: auto;
}
@media (max-width: 767.98px) {
  .Submenu_submenu__oXoEy > ul > li a .Submenu_icon__QL2aK,
  .Submenu_submenu__oXoEy > ul > li button .Submenu_icon__QL2aK {
    margin-right: 1em;
  }
}
.Submenu_submenu__oXoEy > ul > li a .Submenu_icon__QL2aK svg,
.Submenu_submenu__oXoEy > ul > li button .Submenu_icon__QL2aK svg {
  transition: transform 0.3s ease;
}
@media (max-width: 767.98px) {
  .Submenu_submenu__oXoEy > ul > li a .Submenu_icon__QL2aK svg,
  .Submenu_submenu__oXoEy > ul > li button .Submenu_icon__QL2aK svg {
    transform: rotate(90deg);
  }
}
.Submenu_submenu__oXoEy > ul > li a[aria-expanded=true] .Submenu_icon__QL2aK svg,
.Submenu_submenu__oXoEy > ul > li button[aria-expanded=true] .Submenu_icon__QL2aK svg {
  transform: rotate(180deg);
}
@media (max-width: 767.98px) {
  .Submenu_submenu__oXoEy > ul > li a[aria-expanded=true] .Submenu_icon__QL2aK svg,
  .Submenu_submenu__oXoEy > ul > li button[aria-expanded=true] .Submenu_icon__QL2aK svg {
    transform: rotate(270deg);
  }
}
.Submenu_submenu__oXoEy > ul > li + li::before {
  content: "";
  display: block;
  position: absolute;
  left: 2px;
  right: 2px;
  top: 0;
  height: 1px;
  background: var(--foreground-color-1-alpha);
}

.nightMode .Submenu_submenu__oXoEy {
  border: 1px solid var(--background-color-2);
  border-top: none;
}`, "",{"version":3,"sources":["webpack://./src/core/_breakpoints.scss","webpack://./src/views/Template/components/Menu/Submenu.module.scss"],"names":[],"mappings":"AAAA,gBAAA;ACCA;EACE,WAAA;EACA,qCAAA;EACA,yCAAA;EACA,gCAAA;EACA,wBAAA;AACF;ADAI;ECNJ;IAOI,8BAAA;IACA,+BAAA;EAGF;AACF;ADNI;ECIF;IAEI,4BAAA;IACA,4BAAA;EAIJ;EAHI;IACE,4BAAA;IACA,4BAAA;EAKN;AACF;ADII;EC1BJ;IAqBI,WAAA;EAKF;AACF;AAJE;EACE,aAAA;AAMJ;AAJE;EACE,QAAA;EACA,SAAA;EACA,6BAAA;EACA,8CAAA;EACA,UAAA;AAMJ;AAJE;EACE,gBAAA;AAMJ;ADlCI;EC2BF;IAGI,8BAAA;IACA,+BAAA;EAQJ;AACF;AAPI;EACE,kBAAA;AASN;AARM;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,wBAAA;EACA,eAAA;EACA,oBAAA;AAUR;AATQ;;EACE,cAAA;AAYV;AAVQ;;;;EAGE,yBAAA;EACA,aAAA;EACA,wCAAA;EACA,cAAA;EAIA,qCAAA;EACA,gCAAA;AAUV;AAdU;;;;EACE,wBAAA;AAmBZ;AAdQ;;EACE,gBAAA;AAiBV;AAfQ;;EACE,mBAAA;EACA,iBAAA;AAkBV;ADlEI;EC8CI;;IAII,iBAAA;EAqBV;AACF;AApBU;;EACE,+BAAA;AAuBZ;AD5EI;ECoDM;;IAGI,wBAAA;EA0BZ;AACF;AAtBU;;EACE,yBAAA;AAyBZ;ADtFI;EC4DM;;IAGI,yBAAA;EA4BZ;AACF;AAvBQ;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,MAAA;EACA,WAAA;EACA,2CAAA;AAyBV;;AAjBE;EACE,2CAAA;EACA,gBAAA;AAoBJ","sourcesContent":["/* BREAKPOINTS */\n@mixin breakpoint-up($point) {\n  @if $point == sm {\n    @media (min-width: 576px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (min-width: 768px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (min-width: 992px) {\n      @content;\n    }\n  } @else if $point == xl {\n    @media (min-width: 1200px) {\n      @content;\n    }\n  }\n}\n\n@mixin breakpoint-down($point) {\n  @if $point == xs {\n    @media (max-width: 575.98px) {\n      @content;\n    }\n  } @else if $point == sm {\n    @media (max-width: 767.98px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (max-width: 991.98px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (max-width: 1199.98px) {\n      @content;\n    }\n  }\n}\n","@import \"core/_breakpoints.scss\";\n.submenu {\n  z-index: 10;\n  background: var(--background-color-1);\n  box-shadow: 0 3px 5px rgba(black, 0.25);\n  color: var(--foreground-color-1);\n  animation-duration: 0.3s;\n  @include breakpoint-up(md) {\n    border-bottom-left-radius: 1em;\n    border-bottom-right-radius: 1em;\n  }\n  .submenu {\n    @include breakpoint-up(md) {\n      border-bottom-left-radius: 0;\n      border-top-right-radius: 1em;\n      > ul {\n        border-bottom-left-radius: 0;\n        border-top-right-radius: 1em;\n      }\n    }\n  }\n  @include breakpoint-down(sm) {\n    width: 100%;\n  }\n  &.hidden {\n    display: none;\n  }\n  .submenuArrow {\n    width: 0;\n    height: 0;\n    border: 7px solid transparent;\n    border-bottom-color: var(--background-color-1);\n    top: -13px;\n  }\n  > ul {\n    overflow: hidden;\n    @include breakpoint-up(md) {\n      border-bottom-left-radius: 1em;\n      border-bottom-right-radius: 1em;\n    }\n    > li {\n      position: relative;\n      a,\n      button {\n        display: flex;\n        align-items: center;\n        height: 3em;\n        width: 100%;\n        background: none;\n        border: none;\n        color: var(--foreground-color-2);\n        font-weight: var(--bold);\n        cursor: pointer;\n        padding: 0 2em 0 1em;\n        &[aria-haspopup=\"true\"] {\n          padding: 0 1em;\n        }\n        &:hover,\n        &:global(.focus-visible),\n        &[aria-expanded=\"true\"] {\n          transition: all 0.3s ease;\n          outline: none;\n          box-shadow: 0 0 15px rgba(black, 0.25);\n          padding: 1.5em;\n          &[aria-haspopup=\"true\"] {\n            padding: 0 0.5em 0 1.5em;\n          }\n          background: var(--foreground-color-1);\n          color: var(--background-color-1);\n        }\n        > * + * {\n          margin-left: 1em;\n        }\n        .icon {\n          padding-left: 0.5em;\n          margin-left: auto;\n          @include breakpoint-down(sm) {\n            margin-right: 1em;\n          }\n          svg {\n            transition: transform 0.3s ease;\n            @include breakpoint-down(sm) {\n              transform: rotate(90deg);\n            }\n          }\n        }\n        &[aria-expanded=\"true\"] {\n          .icon svg {\n            transform: rotate(180deg);\n            @include breakpoint-down(sm) {\n              transform: rotate(270deg);\n            }\n          }\n        }\n      }\n      + li {\n        &::before {\n          content: \"\";\n          display: block;\n          position: absolute;\n          left: 2px;\n          right: 2px;\n          top: 0;\n          height: 1px;\n          background: var(--foreground-color-1-alpha);\n        }\n      }\n    }\n  }\n}\n\n:global(.nightMode) {\n  .submenu {\n    border: 1px solid var(--background-color-2);\n    border-top: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"submenu": `Submenu_submenu__oXoEy`,
	"hidden": `Submenu_hidden__rA06C`,
	"submenuArrow": `Submenu_submenuArrow__Z84U8`,
	"icon": `Submenu_icon__QL2aK`
};
export default ___CSS_LOADER_EXPORT___;
